import { OrgAuthClaimPage } from "@solomon-apps/shared";
import React from "react";

import { CLIENT_OAUTH_CONFIG } from "@/constants/oauthConfig";

export function ClaimPage(): React.ReactElement {
    return (
        <OrgAuthClaimPage
            apiBase={CLIENT_OAUTH_CONFIG.apiBase}
            appLabel="Company Recipient Console"
        />
    );
}
